/**
 * Community Project public API helpers.
 */

import api from "../../Environment";

export function projectPublicPath(slug) {
  const cleaned = String(slug || "").trim();
  if (!cleaned) {
    return "/projects";
  }
  return `/project/${cleaned}`;
}

export async function fetchProjectBySlug(slug) {
  const cleaned = String(slug || "").trim();
  if (!cleaned) {
    return null;
  }

  try {
    const response = await api.postMethod("project/show", {
      slug: cleaned,
    });
    const body = response && response.data ? response.data : response;
    if (body && body.success && body.data) {
      return body.data;
    }
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * @param {{ featured?: boolean, q?: string, page?: number, per_page?: number }} [opts]
 */
export async function fetchProjectDirectory(opts = {}) {
  const input = {};
  if (opts.featured === true) {
    input.featured = 1;
  } else if (opts.featured === false) {
    input.featured = 0;
  }
  if (opts.q) {
    input.q = String(opts.q).trim();
  }
  if (opts.page) {
    input.page = opts.page;
  }
  if (opts.per_page) {
    input.per_page = opts.per_page;
  }

  try {
    const response = await api.postMethod("project/list", input);
    const body = response && response.data ? response.data : response;
    if (body && body.success && body.data) {
      const projects = Array.isArray(body.data.projects)
        ? body.data.projects
        : [];
      return {
        projects,
        pagination: body.data.pagination || null,
        error: false,
      };
    }
    return { projects: [], pagination: null, error: true };
  } catch (e) {
    return { projects: [], pagination: null, error: true };
  }
}

export function formatMoney(amount, currency) {
  const value = Number(amount);
  if (!Number.isFinite(value)) {
    return "—";
  }
  const code = currency || "USD";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      maximumFractionDigits: 0,
    }).format(value);
  } catch (e) {
    return `${code} ${value.toFixed(0)}`;
  }
}
